import { render, staticRenderFns } from "./group-progress-chart.vue?vue&type=template&id=66321224&scoped=true"
import script from "./group-progress-chart.vue?vue&type=script&lang=js"
export * from "./group-progress-chart.vue?vue&type=script&lang=js"
import style0 from "./group-progress-chart.vue?vue&type=style&index=0&id=66321224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66321224",
  null
  
)

export default component.exports